import { render, staticRenderFns } from "./RevisionModal.vue?vue&type=template&id=afe72e44&scoped=true&"
import script from "./RevisionModal.vue?vue&type=script&lang=js&"
export * from "./RevisionModal.vue?vue&type=script&lang=js&"
import style0 from "./RevisionModal.vue?vue&type=style&index=0&id=afe72e44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe72e44",
  null
  
)

export default component.exports